module.exports = __webpack_public_path__ + "img/cover.7b5dc155.webp";